import { ImageDetailsList, ImageListItem } from "./image-details-list";
import { getImageUrl } from "../../../final-qa/lib/productData";
import React from "react";
import classnames from "classnames";
import { format } from "date-fns";
import { DATE_FNS_SHORT_DATE_FORMAT } from "shared/constants";
import { ATTRIBUTE_KEYS } from "shared/constants/attribute-keys";

export const MatchedProductDetails = ({
    matchedProduct,
    productNumber,
    onZoomCompare,
    imageAttributeGroups,
    isFinalQa,
    isReference,
    isPhysicalRemote,
}) => {
    const { attributes, images, shipmentKey, shipmentProductKey } = matchedProduct;

    const getEditedorUneditedImage = (editedImageUris, uneditedImageUris) => {
        if (editedImageUris && editedImageUris.small) {
            return editedImageUris.small;
        }

        if (uneditedImageUris && uneditedImageUris.small) {
            return uneditedImageUris.small;
        }

        return null;
    };

    const addImageDescription = (editedImageUris) => {
        if (isFinalQa) {
            return null;
        }

        return editedImageUris && editedImageUris.small ? " (Edited)" : " (Unedited)";
    };

    return (
        <ImageDetailsList className={classnames("images-details-list", isFinalQa ? "" : "reduce-width")}>
            <ImageListItem className={classnames("image-info", isFinalQa ? "-small-box" : "-small-box-full")}>
                {isFinalQa && (
                    <h4>
                        CES Product {productNumber} ({matchedProduct.shipmentType})
                    </h4>
                )}
                {!isFinalQa && productNumber && <h4>Product Match {productNumber}</h4>}
                {!isFinalQa && isReference && <h4>{isPhysicalRemote ? "Physical" : "Digital"} Product In Hand</h4>}
                <div className="details">
                    <div className="details-info">
                        {isFinalQa && <span className="txt-bold">Product ID</span>}
                        <span>{matchedProduct.productId}</span>
                    </div>
                    <div className={classnames(isFinalQa ? "details-zoom" : "details-zoom-start")}>
                        <button
                            className="link"
                            onClick={() => onZoomCompare(matchedProduct.productId || matchedProduct.taskContextKey)}
                            hidden={isReference}
                        >
                            Zoom to Compare
                        </button>
                    </div>
                    <div
                        className="attribute-details"
                        style={{ display: isFinalQa ? "none" : "block" }}
                    >
                        {imageAttributeGroups &&
                            imageAttributeGroups.map((attr) => {
                                let value = attributes[attr.uuid];

                                if (attr.key === ATTRIBUTE_KEYS.shipmentLocation) {
                                    value = attributes[attr.uuid] && attributes[attr.uuid].location;
                                }

                                if (attr.key === ATTRIBUTE_KEYS.client) {
                                    value = attributes[attr.uuid] && attributes[attr.uuid].name;
                                }

                                if (value && (attr.key === ATTRIBUTE_KEYS.createdOn || attr.key === ATTRIBUTE_KEYS.postDate)) {
                                    value = format(new Date(value), DATE_FNS_SHORT_DATE_FORMAT);
                                }

                                if (attr.key === ATTRIBUTE_KEYS.assetLinks) {
                                    const displayName = "Digital Flat PDF";

                                    return (
                                        value &&
                                        value.map((link, index) => (
                                            <div key={`${attr.key}_${index}`}>
                                                <span>
                                                    <b>{displayName}:</b>
                                                </span>
                                                <a
                                                    href={link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="txt-no-decoration"
                                                >
                                                    View
                                                </a>
                                            </div>
                                        ))
                                    );
                                }

                                return (
                                    <div key={attr.key}>
                                        <span>
                                            <b>{attr.name}:</b>
                                        </span>
                                        <span>{value}</span>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </ImageListItem>
            <ImageListItem className={`images flex-row ${isReference ? "gray-box" : ""}`}>
                <ImageDetailsList className="product-images">
                    {images.map(
                        (
                            {
                                cxhAssetName,
                                cxHImageAttributeValue,
                                cxHImageAttributeId,
                                imageView,
                                imageViewDescription,
                                editedImageUris,
                                uneditedImageUris,
                            },
                            shotIndex
                        ) => {
                            const useImageUris = getEditedorUneditedImage(editedImageUris, uneditedImageUris);

                            return (
                                <ImageListItem
                                    key={cxHImageAttributeId || shotIndex}
                                    className="product-image-item"
                                >
                                    {!isFinalQa && (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={`/image-browser/${shipmentKey}/${shipmentProductKey}${editedImageUris ? "/edited" : "/unedited"}`}
                                        >
                                            <div className="product-image-container">
                                                <img
                                                    className="image"
                                                    alt={cxhAssetName || imageViewDescription}
                                                    src={useImageUris ? useImageUris : getImageUrl(cxHImageAttributeValue)}
                                                />
                                            </div>
                                        </a>
                                    )}

                                    {isFinalQa && (
                                        <div className="product-image-container">
                                            <img
                                                className="image"
                                                alt={cxhAssetName || imageViewDescription}
                                                src={useImageUris ? useImageUris : getImageUrl(cxHImageAttributeValue)}
                                            />
                                        </div>
                                    )}

                                    <h5>
                                        {cxhAssetName || imageViewDescription || (!isFinalQa && imageView)}
                                        {addImageDescription(editedImageUris)}
                                    </h5>
                                </ImageListItem>
                            );
                        }
                    )}
                </ImageDetailsList>
            </ImageListItem>
        </ImageDetailsList>
    );
};
